export enum LearningPathDropdownEnum {
  Export = 'Export for Current Year',
  ExportNextYear = 'Export for Next Year',
  Clone = 'Clone',
}
